import ProductCTA from './ProductCTA'

export default ProductCTA
